module.exports = __webpack_public_path__ + "media/images/payments/verifone-dark-334584fe7a3b17ffc1c82dc0dee86002.svg";